export const convertValueToHoursAndMinutes = (value) => {
  if (value <= 0) return '-';

  // Convert the value to hours and minutes, rounding to the nearest minute
  let hours = Math.floor(value) || 0;
  let minutes = Math.round((value - hours) * 60) || 0;

  // If rounding minutes resulted in 60, increment the hour
  if (minutes === 60) {
    hours += 1;
    minutes = 0;
  }

  return `${hours ? `${hours}t` : ''} ${minutes ? `${minutes}m` : ''}`.trim();
};
